import { render, staticRenderFns } from "./achievements.vue?vue&type=template&id=04bcf3ba&scoped=true&"
import script from "./achievements.vue?vue&type=script&lang=js&"
export * from "./achievements.vue?vue&type=script&lang=js&"
import style0 from "./achievements.vue?vue&type=style&index=0&id=04bcf3ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcf3ba",
  null
  
)

export default component.exports